import React from "react";
import { Offcanvas, Badge, Card, Row, Col, ProgressBar } from "react-bootstrap";
import { FaEdit, FaExclamationTriangle } from "react-icons/fa";

const DepotDetail = ({ Show, Hide, Title, rowData, depotColumns, eiwrsPermission }) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="lg">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 style={{ fontSize: 14 }} className="mb-1">{rowData?.row?.DEPOTNAME}</h5>
            <span className="text-muted font-monospace small">{rowData?.row?.DEPOTID}</span>
          </div>
          <Badge
            bg="success-subtle"
            style={{ fontSize: 10 }}
            className={`br3 text-success border border-success px-2 text-capitalize mx-2`}
          >
            Active
          </Badge>
        </div>
        <Card className="mb-3">
          <Card.Body className="p-3">
            <Row>
              {depotColumns?.map((item, index) => (
                <Col className="mb-2" key={index} xs={6}>
                  <div className="text-muted small">{item?.columnLabel}</div>
                  <small style={{ fontSize: 12 }}>{rowData?.row?.[item?.columnName]}</small>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
        <Card className="mb-3">
          <Card.Body className="p-3">
            <h6 className="text-uppercase text-muted" style={{ fontSize: "11px", letterSpacing: "0.5px", fontWeight: "700" }}>
              STOCK OVERVIEW
            </h6>
            <div className="d-flex justify-content-between small mb-1">
              <span className="text-muted">Capacity Utilization</span>
              <small>{rowData?.usedKit} / {rowData?.totalKit} ({rowData?.kitProgress}%)</small>
            </div>
            <ProgressBar
              now={rowData?.kitProgress}
              variant={rowData?.kitProgress > 90 ? "danger" : rowData?.kitProgress > 80 ? "warning" : "success"}
              style={{ height: 8 }}
              className="mt-1"
            />
            <div className="d-flex justify-content-between small mt-1">
              <span className="text-muted">{rowData?.kitProgress}% utilized</span>
              {rowData?.kitProgress > 90 &&
                <span style={{ fontSize: 10 }} className="text-danger">
                  <FaExclamationTriangle size={10} className="me-1" />
                  {rowData?.kitProgress === 100 ? "Finished Stock" : "Low Stock"}
                </span>
              }
            </div>
            {((eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) && (rowData?.treatmentList || [])?.length > 0) &&
              <div className="mb-2">
                {(rowData?.treatmentList || [])?.map((treat, key) => (
                  <div className="d-flex justify-content-between align-items-center small py-1 border-bottom border-light">
                    <span className="text-muted">{treat?.treatment}</span>
                    <span className="fw-semibold">
                      {treat?.usedKit} / {treat?.totalKit}
                    </span>
                  </div>
                ))}
              </div>
            }
            <hr className="my-2" />
            <div className="hstack justify-content-between small">
              <div style={{ fontSize: 13 }} className="fw-bold">Total Shipment</div>
              <span className="text-muted">{rowData?.totalShipment}</span>
            </div>
          </Card.Body>
        </Card>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DepotDetail;